import React from "react"
import {
	Box,
	Grid,
	Dialog,
	Button,
	IconButton,
	DialogContent,
	DialogTitle,
	useMediaQuery,
	useTheme,
} from "@mui/material"

import Icon from "@mdi/react"
import { mdiHelpCircle, mdiClose } from "@mdi/js"

const MeasureCylinderDialog = ({ systemConfigurationToolTip }: Props) => {
	const [open, setOpen] = React.useState(false)
	const theme = useTheme()
	const fullScreen = useMediaQuery(theme.breakpoints.down("lg"))

	const handleClickOpen = () => {
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
	}

	return (
		<>
			<Box>
				<div style={{ display: "flex", alignItems: "center" }}>
					<Box mr={1}>
						<strong>Ausführung wählen</strong>
					</Box>
					{systemConfigurationToolTip && (
						<IconButton onClick={handleClickOpen} style={{ padding: 3 }} size="large">
							<Icon path={mdiHelpCircle} size={0.8} color="#4691CE" />
						</IconButton>
					)}
				</div>
				<Dialog
					fullScreen={fullScreen}
					open={open}
					onClose={handleClose}
					maxWidth={"md"}
					aria-labelledby="select-system"
				>
					<DialogTitle
						id="select-system-dialog"
						style={{
							borderBottom: "1px solid #B8BCBF",
						}}
					>
						<div>
							<strong>Wählen Sie hier die Ausführung:</strong>
						</div>
						<Button
							onClick={handleClose}
							color="primary"
							style={{ position: "absolute", top: 13, right: 10 }}
						>
							<Icon path={mdiClose} size={1} />
						</Button>
					</DialogTitle>
					<DialogContent>
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<Box
									py={5}
									dangerouslySetInnerHTML={{ __html: systemConfigurationToolTip }}
								/>
							</Grid>
						</Grid>
					</DialogContent>
				</Dialog>
			</Box>
		</>
	)
}

interface Props {
	systemConfigurationToolTip: string
}

export default MeasureCylinderDialog
